import { render, staticRenderFns } from "./VProposalListItemLinks.vue?vue&type=template&id=b3120636&scoped=true"
import script from "./VProposalListItemLinks.vue?vue&type=script&lang=js"
export * from "./VProposalListItemLinks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3120636",
  null
  
)

export default component.exports